import React from 'react';
import './PageLoader.css';

export default function PageLoader({ text = 'Loading...' }) {
  return (
    <div className="pl-overlay">
      <div className="pl-box">
        <div className="pl-logo-wrap">
          <img src="/cmpy_logo.png" alt="Creative Glass Tec" className="pl-logo" />
        </div>
        <div className="pl-spinner">
          <div className="pl-track" />
          <div className="pl-fill" />
        </div>
        <p className="pl-text">{text}</p>
      </div>
    </div>
  );
}
